/**
 * Inline quick-add on product cards.
 *
 * "+ Quick add" expands a size chip row on the card. Picking a size writes the
 * variant id into the form's hidden [name=id] and enables Add to cart; the theme's
 * own ProductForm (assets/theme.js:2493) handles the submit, cart drawer and errors,
 * because it reads `new FormData(this)` at submit time rather than caching values.
 *
 * All handlers are delegated at document level so cards re-rendered by the facet
 * AJAX swap keep working without re-binding.
 */
(function () {
  const SELECTED = 'is-selected';

  function closePanel(panel) {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    const toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllExcept(keep) {
    document.querySelectorAll('[data-card-quick-add]').forEach((p) => {
      if (p !== keep) closePanel(p);
    });
  }

  function onToggleClick(toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    const opening = panel.hidden;
    // One open panel at a time — two expanded cards in a grid is noisy and pushes
    // the row heights around unpredictably.
    closeAllExcept(opening ? panel : null);

    panel.hidden = !opening;
    toggle.setAttribute('aria-expanded', String(opening));

    if (opening) {
      const first = panel.querySelector('[data-card-size]:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function onSizeClick(btn) {
    const panel = btn.closest('[data-card-quick-add]');
    if (!panel) return;

    panel.querySelectorAll('[data-card-size]').forEach((b) => {
      b.classList.remove(SELECTED);
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add(SELECTED);
    btn.setAttribute('aria-pressed', 'true');

    const input = panel.querySelector('[data-card-variant-id]');
    const submit = panel.querySelector('[data-card-atc]');
    if (input) input.value = btn.dataset.variantId || '';
    if (submit) {
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-card-quick-add-toggle]');
    if (toggle) {
      event.preventDefault();
      onToggleClick(toggle);
      return;
    }

    const close = event.target.closest('[data-card-quick-add-close]');
    if (close) {
      event.preventDefault();
      const panel = close.closest('[data-card-quick-add]');
      closePanel(panel);
      const trigger = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (trigger) trigger.focus({ preventScroll: true });
      return;
    }

    const size = event.target.closest('[data-card-size]');
    if (size && !size.disabled) {
      event.preventDefault();
      onSizeClick(size);
      return;
    }

    // Size guide reuses the theme's existing size-chart modal if one is on the page;
    // otherwise fall through to the product page rather than opening nothing.
    const guide = event.target.closest('[data-card-size-guide]');
    if (guide) {
      event.preventDefault();
      const card = guide.closest('.product-card');
      const link = card && card.querySelector('a[href*="/products/"]');
      if (link) window.location.href = link.getAttribute('href');
      return;
    }

    // Clicking away closes the open panel.
    if (!event.target.closest('[data-card-quick-add]')) closeAllExcept(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllExcept(null);
  });

  // After a successful add the theme opens the cart drawer; collapse the panel so
  // the card returns to its resting state behind it.
  document.addEventListener('cart:refresh', () => closeAllExcept(null));
  if (window.FoxTheme && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => closeAllExcept(null));
  }
})();
